import { render } from "./SearchModal.vue?vue&type=template&id=207e6a2f"
import script from "./SearchModal.vue?vue&type=script&lang=js"
export * from "./SearchModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__